import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './PaymentFailure.css';
import { FaTimesCircle, FaRedo, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';

const PaymentFailure = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState(location.state);

  // Check for fallback data in URL parameters or sessionStorage if no state data
  useEffect(() => {
    if (!data) {
      // First try URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('error')) {
        const urlData = {
          error: {
            error: urlParams.get('error'),
            code: urlParams.get('code') || 'UNKNOWN_ERROR'
          },
          bookingData: {
            beds: parseInt(urlParams.get('beds')) || 1,
            nights: parseInt(urlParams.get('nights')) || 1,
            total: parseInt(urlParams.get('total')) || 0,
            start: urlParams.get('checkIn') || '',
            end: urlParams.get('checkOut') || ''
          }
        };
        setData(urlData);
        // Clean URL after extracting data
        window.history.replaceState(null, '', '/payment-failure');
      } else {
        // Fallback to sessionStorage
        const storedError = sessionStorage.getItem('paymentError');
        if (storedError) {
          try {
            const errorData = JSON.parse(storedError);
            setData(errorData);
            // Clear the stored error data after using it
            sessionStorage.removeItem('paymentError');
          } catch (error) {
            console.error('Error parsing stored payment error data:', error);
          }
        }
      }
    }
  }, [data]);

  const handleRetryPayment = () => {
    // Navigate back to booking page with the same data
    if (data) {
      navigate('/booking', { state: data });
    } else {
      navigate('/');
    }
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <>
      <Header />
      <div className="payment-failure-outer">
        <div className="payment-failure-container">
          <div className="failure-header">
            <FaTimesCircle className="failure-icon" />
            <h2>Payment Failed</h2>
            <p className="failure-message">
              We're sorry, but your payment could not be processed at this time.
            </p>
          </div>

          <div className="failure-details">
            <div className="failure-reasons">
              <h3>Common reasons for payment failure:</h3>
              <ul>
                <li>Insufficient funds in your account</li>
                <li>Network connectivity issues</li>
                <li>Incorrect card details</li>
                <li>Bank server temporarily unavailable</li>
                <li>Transaction timeout</li>
              </ul>
            </div>

            {data && (
              <div className="booking-summary-failure">
                <h3>Your Booking Details</h3>
                <div className="summary-row">
                  <span>Check-in:</span>
                  <span>{data.bookingData?.start}</span>
                </div>
                <div className="summary-row">
                  <span>Check-out:</span>
                  <span>{data.bookingData?.end}</span>
                </div>
                <div className="summary-row">
                  <span>Beds:</span>
                  <span>{data.bookingData?.beds}</span>
                </div>
                <div className="summary-row">
                  <span>Total Amount:</span>
                  <span>₹{data.bookingData?.total}</span>
                </div>
              </div>
            )}
          </div>

          <div className="failure-actions">
            <button className="btn btn-primary retry-btn" onClick={handleRetryPayment}>
              <FaRedo className="btn-icon" />
              Retry Payment
            </button>
            <button className="btn btn-secondary home-btn" onClick={handleGoHome}>
              <FaHome className="btn-icon" />
              Go to Home
            </button>
          </div>

          <div className="contact-support">
            <h3>Need Help?</h3>
            <p>If you continue to face issues, please contact our support team:</p>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+91 90327 97797</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>booking@skylinebackpackers.in</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentFailure;
